var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video"},[_c('div',{staticClass:"title"}),_c('div',{ref:"scrollview",staticClass:"videoBox"},_vm._l((_vm.videoList),function(item,index){return _c('div',{key:item.id,staticClass:"videoItem"},[_c('videoPlay',{attrs:{"videoUrl":item.videoUrl}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }